/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Settingserializer } from './Settingserializer';
import {
  SettingserializerFromJSON,
  SettingserializerFromJSONTyped,
  SettingserializerToJSON,
} from './Settingserializer';

/**
 *
 * @export
 * @interface PaginatedSettingserializerList
 */
export interface PaginatedSettingserializerList {
  /**
   *
   * @type {number}
   * @memberof PaginatedSettingserializerList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedSettingserializerList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedSettingserializerList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Settingserializer>}
   * @memberof PaginatedSettingserializerList
   */
  results: Array<Settingserializer>;
}

/**
 * Check if a given object implements the PaginatedSettingserializerList interface.
 */
export function instanceOfPaginatedSettingserializerList(value: object): value is PaginatedSettingserializerList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedSettingserializerListFromJSON(json: any): PaginatedSettingserializerList {
  return PaginatedSettingserializerListFromJSONTyped(json, false);
}

export function PaginatedSettingserializerListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedSettingserializerList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(SettingserializerFromJSON),
  };
}

export function PaginatedSettingserializerListToJSON(value?: PaginatedSettingserializerList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(SettingserializerToJSON),
  };
}
